import React, { memo, useState, useEffect, Fragment } from 'react';
import Modal from 'components/Tvendo/Common/ModalBase';
import { WithApp } from 'contexts/appContext';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, TableContainer } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import SweetAlert from 'react-bootstrap-sweetalert';
import sweetAlertStyles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import { wsCreate } from 'services/WService';

const useStyles = makeStyles({
  ...sweetAlertStyles,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: 'bold'
  }
});

export default WithApp(function ModalOuput(props) {
  const classes = useStyles();
  const { ordersProducts = [], purchProducts = [], purchOrderId, purchaseId, reload } = props;
  const [comments, setComments] = useState({});
  const [alert, setAlert] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const handleCommentChange = (itemCode, value) => {
    setComments(prev => ({ ...prev, [itemCode]: value }));
  };

  const matchedProducts = ordersProducts
    .map(orderItem => {
      const purchItem = purchProducts.find(p => p.ItemCode === orderItem.ItemCode);
      if (!purchItem) return null;

      const purchQuantity = Number(purchItem.quantity ?? 0);
      const orderQuantity = Number(orderItem.Quantity ?? 0);

      if (purchQuantity === orderQuantity) {
        return null;
      }

      return {
        ItemCode: orderItem.ItemCode,
        ItemName: orderItem.ItemName,
        orderQuantity,
        purchQuantity,
        difference: purchQuantity - orderQuantity,
        extra: false,
      };
    })
    .filter(Boolean);

  const extraProducts = purchProducts
    .filter(purchItem => !ordersProducts.find(o => o.ItemCode === purchItem.ItemCode))
    .map(purchItem => ({
      ItemCode: purchItem.ItemCode,
      ItemName: purchItem.ItemName,
      orderQuantity: null,
      purchQuantity: Number(purchItem.quantity ?? 0),
      difference: Number(purchItem.quantity ?? 0),
      extra: true,
    }));

  const rowsToShow = [...matchedProducts, ...extraProducts];

  // Para enviar en el dataForce (TODOS los productos)
  const allProductsToSend = purchProducts.map(purchItem => {
    const orderItem = ordersProducts.find(o => o.ItemCode === purchItem.ItemCode);
    const purchQuantity = Number(purchItem.quantity ?? 0);
    const orderQuantity = Number(orderItem?.Quantity ?? 0);

    return {
      ItemCode: purchItem.ItemCode,
      orderQuantity,
      purchQuantity,
      comment: comments[purchItem.ItemCode] || ''
    };
  });
  const getRowStyle = (row) => {
    if (row.extra) {
      return { backgroundColor: '#e6d2f8' };
    }
    if (row.difference > 0) {
      return { backgroundColor: '#d2f8d2' };
    } else if (row.difference < 0) {
      return { backgroundColor: '#f8d2d2' };
    }
    return {};
  };

  const confirmAndSubmit = () => new Promise((resolve, reject) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="¿Desea validar esta orden de compra?"
        onConfirm={async () => {
          setAlert(null);
          setSubmitting(true);
          const response = await wsCreate('purch/purchase-order-diferencia', {
            purch_order_id: purchOrderId,
            products: allProductsToSend,
            validateOrder: 'Y',
            purch_purchase_id: purchaseId,
          });
          setSubmitting(false);
          if (response.success) {
            props.showNotify(response.message);
            if (reload) reload();
            resolve();
          } else {
            props.showNotify(
              `${response.message}\n${response?.data ? response.data : ''}`,
              'error',
            );
            reject(new Error(response.message));
          }
        }}
        onCancel={() => {
          setAlert(null);
          reject(new Error('cancelled'));
        }}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
        closeOnClickOutside={false}
      >
        Se enviarán las cantidades comparadas entre la orden de compra y la mercadería.
      </SweetAlert>
    );
  });
  return (
    <>
      {alert}
      <Modal
        title={`Validación de orden de compra para mercadería XML`}
        model={{ open: props.open }}
        setOpen={props.onClose}
        showNotify={props.showNotify}
        reload={reload}
        entity={'purch/purchase-order-diferencia'}
        arrDataResponse
        disabledSave={submitting}
        onSubmit={confirmAndSubmit}
        dataForce={{
          purch_order_id: purchOrderId,
          products: allProductsToSend,
          validateOrder: 'Y',
          purch_purchase_id: purchaseId
        }}
      >
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="tabla de productos">
            <TableHead>
              <TableRow>
                <TableCell>Código</TableCell>
                <TableCell>Nombre</TableCell>
                <TableCell align="center">Cantidad Orden</TableCell>
                <TableCell align="center">Cantidad Compra</TableCell>
                <TableCell align="center">Comentario</TableCell>
              </TableRow>
            </TableHead>
              <TableBody>
                {purchProducts.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No se encontraron productos relacionados a esta compra. Selecciona otra para continuar con la validación
                    </TableCell>
                  </TableRow>
                )}

                {rowsToShow.length === 0 && purchProducts.length > 0 && (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No se encontraron diferencias. Valida la orden de compra para continuar correctamente.
                    </TableCell>
                  </TableRow>
                )}

                {rowsToShow.map((product) => (
                  <TableRow
                    key={product.ItemCode}
                    style={getRowStyle(product)}
                  >
                    <TableCell>{product.ItemCode}</TableCell>
                    <TableCell>{product.ItemName}</TableCell>
                    <TableCell align="center">
                      {product.extra ? 'Sin orden' : product.orderQuantity}
                    </TableCell>
                    <TableCell align="center">{product.purchQuantity}</TableCell>
                    <TableCell align="center">
                      <TextField
                        fullWidth
                        label="Comentario"
                        type="text"
                        value={comments[product.ItemCode] || ''}
                        onChange={(e) => handleCommentChange(product.ItemCode, e.target.value)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
          </Table>
        </TableContainer>
      </Modal>
    </>
  );
});

